export default "__VITE_ASSET__YELythxz__"